import React, { useState, useEffect } from "react";
import "./App.css";
import DutyList from "./components/DutyList";

import { useLocation, useNavigate } from "react-router-dom";

import { Route, Routes } from "react-router-dom";
import DutyDetails from "./components/DutyDetails";

import Login from "./Login/Login";

import AuthService from "./services/auth.service";
import { useStateContext } from "./contexts/ContextProvider";
import CrewList from "./components/CrewList";
import Header from "./components/Header";
import ControlPointDuty from "./components/ControlPointDuty";
import Logsheet from "./components/Logsheet";
import ExtraDutyLogsheet from "./components/ExtraDutyLogsheet";

const App = () => {
  const { isLoggedIn, setIsLoggedIn, TEST_URL, setUser } = useStateContext();

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    // console.log(user && user);
    if (user) {
      setIsLoggedIn(true);
      setUser(user);
      if (location.pathname === "/" || location.pathname === "") navigate("/");
    } else {
      setIsLoggedIn(false);
      setUser(null);
      // window.location.href = `${TEST_URL}/Forms/login.aspx`;
    }
  }, []);

  return (
    <>
      {isLoggedIn ? (
        <>
          <div className="main">
            <div className="container-fluid ps-0 pe-0">
              <Header />
              <div className="main-content">
                <Routes>
                  <Route path="/" exact element={<DutyList />} />
                  <Route path="/dutylist" exact element={<DutyList />} />
                  <Route path="/crewList" exact element={<CrewList />} />
                  {/* <Route path="/controlPointDuty" exact element={<ControlPointDuty />} /> */}
                  {/* <Route path="/ex_logsheet" exact element={<ExtraDutyLogsheet />} /> */}
                </Routes>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Routes>
            <Route path="/" exact element={<Login />} />
          </Routes>
        </>
      )}
    </>
  );
};

export default App;
